import gql from 'graphql-tag';

export const UTILITY_CREDENTIAL_FRAGMENT = gql`
  fragment UtilityCredentialData on UtilityCredential {
    id
    type
    username
    verificationStatus
    utility {
      id
      displayName
      overrideEmailIsUsername
    }
  }
`;

export const GET_UTILITY_SYNC_DATA = gql`
  query GetUtilitySyncData($accountId: Int!) {
    account(id: $accountId) {
      id
      utilityCredentials {
        ...UtilityCredentialData
      }
    }
  }
  ${UTILITY_CREDENTIAL_FRAGMENT}
`;

export const GET_UTILITY_CONNECT_TOKEN = gql`
  query getUtilityConnectToken($utilityCredentialId: Int!) {
    utilityCredentialConnectToken(id: $utilityCredentialId)
  }
`;

export const getUtilityConnectTokenMock = {
  utilityCredentialConnectToken: 'fakeToken',
};

export const getUtilitySyncDataMock = {
  account: {
    id: 2,
    utilityCredentials: [
      {
        id: 3,
        __typename: 'UtilityCredential',
        username: 'overide@hey.com',
        verificationStatus: 'correct',
        type: 'fakeType',
        utility: {
          displayName: 'Pepco',
          id: 1111,
          overrideEmailIsUsername: true,
        },
      },
      {
        id: 2,
        __typename: 'UtilityCredential',
        username: 'mylogin',
        verificationStatus: 'correct',
        type: 'fakeType',
        utility: {
          displayName: 'ConEd',
          id: 2222,
          overrideEmailIsUsername: false,
        },
      },
      {
        id: 4,
        __typename: 'UtilityCredential',
        username: 'mylogin@arcadia.com',
        verificationStatus: 'incorrect',
        type: 'fakeType',
        utility: {
          displayName: 'BG&E',
          id: 3333,
          overrideEmailIsUsername: false,
        },
      },
    ],
  },
};
